import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Recurring from 'components/Shared/Icons/Recurring';
import RecurringNoticeWrapper from 'components/Shared/RecurringNoticeWrapper/RecurringNoticeWrapper';
import { colors, breakpoints } from 'styles/cp';

export interface Props {
  autoPayInterval: string;
}

export const AutopayNotice: React.FC<Props> = ({ autoPayInterval = '' }) => {
  return (
    <Fragment>
      <RecurringNoticeWrapper>
        <div className="autopay-notice autopay-header">
          <FormattedMessage id="AUTOPAY_SUCCESS_SCREEN_HEADER" defaultMessage="Next autopay" />
        </div>
        <div className="autopay-recurring-msg">
          <div className="description-icon" aria-label="Recurring Icon">
            <Recurring width={24} height={24} color={colors.green} />
          </div>
          <div className="description">
            <FormattedMessage
              id="AUTOPAY_SUCCESS_SCREEN"
              defaultMessage="Check your email foradditional details."
              values={{ 0: autoPayInterval }}
            />
          </div>
        </div>
      </RecurringNoticeWrapper>

      <style jsx>{`
        .autopay-header {
          text-align: left;
          display: block;
          font-family: AvenirNextforINTUIT-Demi;
          font-size: 14px;
          color: ${colors.gray};

          @media screen and (max-width: ${breakpoints.sm}) {
            font-size: 14px;
            padding-right: 4px;
          }
        }

        .autopay-recurring-msg {
          display: flex;
          align-items: center;
          font-size: 13px;

          color: ${colors.gray};

          .description-icon {
            padding-right: 3px;
            margin-top: 5px;
          }

          .description {
            display: flex;
            text-align: left;
            padding-left: 8px;
            padding-top: 8px;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default AutopayNotice;
